import { PanelBase } from '../ui/panel_base.js';
import { AccountFormMixin } from './account_form_mixin.js';

/**
 * A base class for account panels.
 */
class AccountPanelBase extends AccountFormMixin(PanelBase) {
  initialize() {
    super.initialize();

    this.classList.add('account-panel');
    this.setMessageBox();
  }
}

export { AccountPanelBase };
